// Common phases shared across all scenarios
export var CommonMetricPhase;
(function (CommonMetricPhase) {
    CommonMetricPhase["Interactive"] = "Interactive";
})(CommonMetricPhase || (CommonMetricPhase = {}));
// Application-specific phases
export var ApplicationMetricPhase;
(function (ApplicationMetricPhase) {
    ApplicationMetricPhase["ExplorerInitialized"] = "ExplorerInitialized";
    ApplicationMetricPhase["PlatformConfigured"] = "PlatformConfigured";
    ApplicationMetricPhase["DatabasesFetched"] = "DatabasesFetched";
    ApplicationMetricPhase["CollectionsLoaded"] = "CollectionsLoaded";
    ApplicationMetricPhase["DatabaseTreeRendered"] = "DatabaseTreeRendered";
})(ApplicationMetricPhase || (ApplicationMetricPhase = {}));
